import EsimFilterBar from "../../components/esim/filters/EsimFilterBar";
import EsimReservations from "../../components/esim/EsimReservations";

const EsimPage = () => {
  return (
    <>
      <EsimFilterBar />
      <EsimReservations />
    </>
  );
};

export default EsimPage;
